/**
 * /admin/team — Team management (route shell).
 * Screen impl in `./team-screen.tsx`, dynamic-imported via lazyRouteComponent.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/team')({
  component: lazyRouteComponent(() => import('./team-screen'), 'AdminTeam'),
});
